import React, { Component } from 'react';
import FilterModal from './Filters/FilterModal';
import FilterClient from './Filters/FilterClient';
import ClientList from './ClientList';
import { Grid, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { showLoading, hideLoading } from '../../store/actions/LoadingActions';
import { filterAdminClient } from '../../configs/environments/firebase/firebaseApp';
import { withStyles } from '@material-ui/styles';
import { compose } from 'recompose'

const styles = () => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    grid: {
        justifyContent: 'space-between',
        margin: '0 0 0 40px',
        width: '87.4%',
    },
    title: {
        color: '#10587f',
        fontSize: 32,
        fontWeight: 'bold',
        margin: '15px 0 33px 0',
    },
    buttonsContainer: {
        display: 'flex',
        margin: '15px 0 0 0',
    },
    showAll: {
        width: 168,
        height: 40,
        borderRadius: 20,
        border: '1px solid #013957',
        textTransform: 'inherit',
        backgroundColor: 'transparent',
        color: '#013957',
        fontSize: 16,
        margin: '0 24px 0 0',
    },
    filterButton: {
        width: 120,
        height: 40,
        borderRadius: 20,
        border: '1px solid #013957',
        textTransform: 'inherit',
        backgroundColor: 'transparent',
        color: '#013957',
        fontSize: 16,
        margin: '0 24px 0 0',
    },
    filterIcon: {
        margin: '0 10px 0 0',
    },
})

class AdminClient extends Component {

    state = {
        showFilter: true,
        openFilterModal: false,
        flagEvery: false,
    }

    handleShowFilter = () => {
        const { showFilter } = this.state
        this.setState({
            showFilter: !showFilter
        })
    }

    searchEvery = async () => {
        const { showLoading, hideLoading } = this.props
        showLoading()
        try {
            const params = { page: 1, searchEvery: true } 
            const res = await filterAdminClient(params)
            console.log('res', res);
            this.setState({
                openFilterModal: false,
                showFilter: false,
                flagEvery: true
            })
            hideLoading()
            return res
        } catch (error) {
            console.log(error);
            this.setState({
                openFilterModal: false,
                showFilter: false,
                flagEvery: true
            })
            hideLoading()
        }
    }

    handleFilterModal = () => {
        const { openFilterModal } = this.state;
        this.setState({
            openFilterModal: !openFilterModal
        })
    }

    handleFlagEvery = (flag) => {
        this.setState({
            flagEvery: flag
        })
    }

    render() {
        const { showFilter, openFilterModal, flagEvery } = this.state;
        const { classes } = this.props;
        
        return (
            <div className={classes.container}>
                <Grid
                    container
                    direction='row'
                    className={classes.grid}
                >
                    <p className={classes.title}>
                        {flagEvery && !showFilter ?
                            'Todos los clientes registrados en la plataforma' :
                        showFilter ?
                            'Información de clientes' :
                            'Resultados de filtro'
                        }
                    </p>
                    <div className={classes.buttonsContainer}>
                        {showFilter ?
                            <Button
                                type="button"
                                onClick={this.searchEvery}
                                className={classes.showAll}
                            >
                                Mostrar todos
                            </Button> :
                            <Button
                                type="submit"
                                onClick={this.handleFilterModal}
                                className={classes.filterButton}
                            >
                                <img
                                    src='/img/icons/filters.svg'
                                    alt='filter'
                                    className={classes.filterIcon}
                                />
                                Filtros
                            </Button>
                        }
                    </div>
                </Grid>
                {showFilter ?
                    <FilterClient
                        handleShowFilter={this.handleShowFilter}
                        handleFlagEvery={this.handleFlagEvery}
                    /> :
                    <ClientList />
                }
                <FilterModal
                    open={openFilterModal}
                    handleClose={this.handleFilterModal}
                    content={
                        <FilterClient
                            isModal
                            showEvery
                            searchEvery={this.searchEvery}
                            handleClose={this.handleFilterModal}
                            handleFlagEvery={this.handleFlagEvery}
                        />
                    }
                />
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
})

const AdminClientCompose = compose(
    connect(null, mapDispatchToProps),
    withStyles(styles)
)(AdminClient)

export default AdminClientCompose;
